module.exports = __webpack_public_path__ + "static/media/linkedin.4533e974.svg";